import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import services from '../services';
import { TableContent } from '../../Common/Table/tableContent';
import { search, SearchFeild } from '../../Common';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import groupService from '../../Group/services';
import { EstateSchemaObject } from '../EstateSchema';
import { validateProperty, validate } from "../../Common"
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi'
import $ from 'jquery';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';

const screenCode = 'ESTATE';

export function EstateListing(props) {

    const [estates, setEstates] = useState([]);
    const [groups, setGroups] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchFilter, setSearchFilter] = useState({
        groupID: 0
    });
    const contentRowNames = ["operationEntityCode", "operationEntityName", "isActive"]
    const schema = Joi.object(EstateSchemaObject).options({ allowUnknown: true });
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false
    });

    useEffect(() => {
    trackPromise(
        getPermissions()
        )
    }, []);

    useEffect(() => {
    trackPromise(
        getGroupsForDropdown()
)
        getPermissions();
    }, []);

    useEffect(() => {
    trackPromise(
    handleSearch()
    )

    }, [searchFilter.groupID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWESTATELISITNG');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITESTATE');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchFilter({
            ...searchFilter,
            groupID: token.groupID
        });
        
        getGroupsForDropdown();
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

   
    function destroyDataTable(){
        $('#example').DataTable().destroy();
    }

    function createDataTable(){
        $('#example').DataTable();
    }

    async function getAllEstates(){
        var data
        data = await services.getAll()
        destroyDataTable()
        setEstates(data)
        createDataTable()
    }

    function handleClick(estates) {
        props.history.push({
            pathname: 'estates/addEdit',
            data: estates,
            edit: true
        })
    }


    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function handleChange(e) {
        
        const target = e.target
        const value = (target.name === 'isActive' || target.name === 'isErpEnabled') ? target.checked : target.value


        const error = { ...errors }
        const errorMessage = validateProperty(target, EstateSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]
        
        setSearchFilter({
            ...groups,
            [e.target.name]: value
        })
     
        setErrors(error)
    }

    async function handleSearch() {
        
        if(searchFilter.groupID != 0){
            const response = await services.getEstatesForDropdownByGroupID(searchFilter.groupID);
       
            if (response.data == null || response.data == undefined) {
                setIsTableHide(true)
            }
            else {
                setIsTableHide(false);
                destroyDataTable();
                setEstates(response.data);
                createDataTable();
            }
        }
    }

    return (
        <Fragment>
        <LoadingSpinerComponent />
        <div className="row">
            <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Estates"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Estate"
                            path="estates/addEdit" />
                    <div className="card-body">
                    <form onSubmit={(e) => handleSearch(e)}>
                                <div className="form-group row">
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            value={searchFilter.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                </div>
                            </form>
                          
                       
                        <div className="table-responsive row-top-gap" hidden={isTableHide}>
                            <table id="example" className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                        <th>Estate Code</th>
                                        <th>Estate Name</th>
                                        <th>Status</th>
                                        {permissionList.isAddEditEnabled ? <th>Actions</th> : null}
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContent
                                        data={estates}
                                        hasEdit={permissionList.isAddEditEnabled}
                                        contentRowNames={contentRowNames}
                                        handleClick={handleClick}
                                        hasEdit={permissionList.isAddEditEnabled}
                                    />
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
    )
}